const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('fof-blog', 'forum/pages/BlogOverview');